export const API_URL = "https://api.domain.tld";
export const CLOUDFLARE_TURNSTILE_SITEKEY = "Cloudflare Turnstile Sitekey";
export const CLOUDFLARE_TURNSTILE_CHECKOUT_SITEKEY = "Cloudflare Turnstile Invisible Sitekey";
export const TELEGRAM_CHANNEL_URL = "https://telegram.org/";
export const LOGO_URL = "Logo PNG URL";
export const STORE_NAME = "TopAlts";
export const TELEGRAM_SUPPORT_BOT_USERNAME = "TopAltsSupport_Bot";